module.exports = __webpack_public_path__ + "media/urgent.b76cf7a7.mp3";